module.exports = __webpack_public_path__ + "img/82.6dd77b1c.svg";